import { Component } from 'react';
import { LoadingSpinner } from '../../../../ui/loadingSpinner';
import {
    SEND_VERIFICATION_SMS,
    TOGGLE_ADD_PHONE_NUMBER
} from '../../OnfidoVerificationModal.actions';
import styles from './SelectPhoneNumberForm.module.css';
import messages from '../../OnfidoVerificationModal.messages';
import { SelectPhoneNumber } from '../../selectPhoneNumber/SelectPhoneNumber';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { InjectedFormProps, getFormValues, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { Dispatch } from 'redux';
import { RootState } from '@iwProvider/configureStore';
import { TDeserialisedPerson } from '../../OnfidoVerificationModal.types';

const formConfiguration = {
    form: 'onfidoVerification'
};

const mapStateToProps = (state: RootState) => ({
    ...state.onfidoVerificationModal,
    onfidoFormValues: getFormValues('onfidoVerification')(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    sendSMS: (person: TDeserialisedPerson, phoneNumber: string) =>
        dispatch({ type: SEND_VERIFICATION_SMS, person, phoneNumber }),
    toggleAddPhoneNumber: (personUID: string) =>
        dispatch({ type: TOGGLE_ADD_PHONE_NUMBER, personUID })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

type TComponentProps = {
    person: TDeserialisedPerson;
};
type TProps = PropsFromRedux & TComponentProps & InjectedFormProps;

class SelectPhoneNumberForm extends Component<TProps> {
    handleFormSubmit = (person: TDeserialisedPerson) => {
        const { onfidoFormValues } = this.props;
        // @ts-expect-error - This isn't inferring any types
        const phoneNumber = onfidoFormValues[person.uid];
        this.props.sendSMS(person, phoneNumber);
    };

    renderButtonMessage(person: TDeserialisedPerson) {
        if (person.SMSPending) {
            return (
                <LoadingSpinner
                    data-testid="onfido-loading-spinner"
                    className={styles.loading}
                />
            );
        } else if (person.onfidoStatus.includes('Verifying')) {
            return <FormattedMessage {...messages.resendMessage} />;
        }

        return <FormattedMessage {...messages.sendText} />;
    }

    render() {
        const { person, onfidoFormValues, handleSubmit, toggleAddPhoneNumber } =
            this.props;
        // @ts-expect-error - This isn't inferring any types
        const hasSelectedNumber = onfidoFormValues?.[person.uid];
        const disabledStyles = !hasSelectedNumber
            ? styles.sendSMSDisabled
            : null;
        const isVerified = person.onfidoStatus === 'Verified';
        return (
            <form
                onSubmit={handleSubmit(() => this.handleFormSubmit(person))}
                className={styles.SelectPhoneNumberForm}
            >
                <div className={styles.SelectPhoneNumberFormWrapper}>
                    <SelectPhoneNumber
                        name={`${person.uid}`}
                        options={person.phones}
                        disabled={isVerified || person.reachedMaxOnfidoAttempts}
                        addNewNumber={() => toggleAddPhoneNumber(person.uid)}
                    />

                    <button
                        type="submit"
                        disabled={
                            !hasSelectedNumber ||
                            person.SMSPending ||
                            isVerified ||
                            person.reachedMaxOnfidoAttempts
                        }
                        className={classNames(styles.sendSMS, disabledStyles)}
                    >
                        {this.renderButtonMessage(person)}
                    </button>
                </div>
            </form>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default reduxForm<object, any>(formConfiguration)(
    connect(mapStateToProps, mapDispatchToProps)(SelectPhoneNumberForm)
);
